import { DecoratorNode } from 'lexical';
import React from 'react';

/**
 * Table Menu Button Node following official Lexical guidelines
 * Creates a DecoratorNode that renders a menu button for table interactions
 */
export class TableMenuButtonNode extends DecoratorNode {
  __cellKey;
  __onMenuAction;

  static getType() {
    return 'table-menu-button';
  }

  static clone(node) {
    return new TableMenuButtonNode(node.__cellKey, node.__onMenuAction, node.__key);
  }

  constructor(cellKey, onMenuAction, key) {
    super(key);
    this.__cellKey = cellKey;
    this.__onMenuAction = onMenuAction;
  }

  createDOM(config) {
    const wrapper = document.createElement('span');
    wrapper.className = 'table-menu-button-wrapper';
    wrapper.style.cssText = `
      position: absolute;
      top: -8px;
      right: -8px;
      z-index: 100;
    `;
    return wrapper;
  }

  updateDOM() {
    return false;
  }

  setCellKey(cellKey) {
    const writableNode = this.getWritable();
    writableNode.__cellKey = cellKey;
  }

  getCellKey() {
    return this.__cellKey;
  }

  setOnMenuAction(onMenuAction) {
    const writableNode = this.getWritable();
    writableNode.__onMenuAction = onMenuAction;
  }

  getOnMenuAction() {
    return this.__onMenuAction;
  }

  decorate() {
    return (
      <TableMenuButton 
        cellKey={this.__cellKey}
        onMenuAction={this.__onMenuAction}
      />
    );
  }

  isInline() {
    return true;
  }

  isKeyboardSelectable() {
    return false;
  }

  canBeEmpty() {
    return false;
  }

  canInsertTextBefore() {
    return false;
  }

  canInsertTextAfter() {
    return false;
  }

  exportJSON() {
    return {
      type: 'table-menu-button',
      cellKey: this.__cellKey,
      version: 1
    };
  }

  static importJSON(serializedNode) {
    const { cellKey } = serializedNode;
    const node = new TableMenuButtonNode(cellKey, null);
    return node;
  }
}

// React component for the menu button
function TableMenuButton({ cellKey, onMenuAction }) {
  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    console.log('Menu button clicked for cell:', cellKey);
    
    if (onMenuAction) {
      const rect = e.target.getBoundingClientRect();
      // Pass the button element as reference for smart positioning
      onMenuAction({ 
        clientX: rect.right, 
        clientY: rect.bottom,
        referenceElement: e.target
      }, cellKey);
    }
  };

  return (
    <button
      className="table-menu-button"
      onClick={handleClick}
      style={{
        position: 'absolute',
        background: '#4f46e5',
        color: 'white',
        border: 'none',
        borderRadius: '50%',
        width: '24px',
        height: '24px',
        fontSize: '12px',
        fontWeight: 'bold',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 100,
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        transition: 'all 0.2s ease',
        top: '-8px',
        right: '-8px'
      }}
      onMouseEnter={(e) => {
        e.target.style.background = '#3730a3';
        e.target.style.transform = 'scale(1.1)';
      }}
      onMouseLeave={(e) => {
        e.target.style.background = '#4f46e5';
        e.target.style.transform = 'scale(1)';
      }}
      title="Table options"
    >
      ⌄
    </button>
  );
}

export function $createTableMenuButtonNode(cellKey, onMenuAction) {
  return new TableMenuButtonNode(cellKey, onMenuAction);
}

export function $isTableMenuButtonNode(node) {
  return node instanceof TableMenuButtonNode;
}
